/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteCalendarSummaryDtoBase
 * auto generated base class for the model RouteCalendarSummaryDtoModel.
 *
 * Lightweight route summary for the calendar view
 */
export const RouteCalendarSummaryDtoModelBase = ModelBase
  .named('RouteCalendarSummaryDto')
  .props({
    __typename: types.optional(types.literal("RouteCalendarSummaryDto"), "RouteCalendarSummaryDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.null, types.string),
    startDate: types.union(types.undefined, types.string),
    hexColor: types.union(types.undefined, types.string),
    isDispatched: types.union(types.undefined, types.boolean),
    isStarted: types.union(types.undefined, types.boolean),
    driverName: types.union(types.undefined, types.null, types.string),
    shiftStartTime: types.union(types.undefined, types.null, types.string),
    shiftEndTime: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteCalendarSummaryDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
  get startDate() { return this.__attr(`startDate`) }
  get hexColor() { return this.__attr(`hexColor`) }
  get isDispatched() { return this.__attr(`isDispatched`) }
  get isStarted() { return this.__attr(`isStarted`) }
  get driverName() { return this.__attr(`driverName`) }
  get shiftStartTime() { return this.__attr(`shiftStartTime`) }
  get shiftEndTime() { return this.__attr(`shiftEndTime`) }
}
export function selectFromRouteCalendarSummaryDto() {
  return new RouteCalendarSummaryDtoModelSelector()
}

export const routeCalendarSummaryDtoModelPrimitives = selectFromRouteCalendarSummaryDto().uuid.name.startDate.hexColor.isDispatched.isStarted.driverName.shiftStartTime.shiftEndTime
